import Vue from 'vue';
import PasswordComplexityValidator from 'password-validator';

export default class PasswordValidator {

    /**
     *
     * @param form the contact form
     */
    constructor(password, confirmPassword) {
        this.errors = {};
        this.password = password;
        this.confirmPassword = confirmPassword;
    }

    flushError(name) {
        Vue.set(this.errors, name, "");
    }

    validatePassword() {
        this.flushError('password');

        let validator = new PasswordComplexityValidator();
        validator.is().min(8)
            .has().uppercase()
            .has().lowercase()
            .has().digits();

        if (!this.password || !validator.validate(this.password, {})) {
            Vue.set(this.errors, 'password', 'page_setcontact.error.passwordcomplexity');
        } else {
            /**
             * Seperate symbol test, because validator doesn't accept § as special char
             */
            validator.has().symbols();
            let specialCharRegEx = /[§]/;
            if(!validator.validate(this.password, {}) && !specialCharRegEx.test(this.password)){
                Vue.set(this.errors, 'password', 'page_setcontact.error.passwordcomplexity');
            }
        }
    }

    validateConfirmPassword() {
        this.flushError('confirmPassword');

        if (!(this.password === this.confirmPassword)) {
            Vue.set(this.errors, 'confirmPassword', 'page_setcontact.error.passwordnotmatching');
        }
    }

    validateAll() {
        this.validatePassword();
        this.validateConfirmPassword();
    }
}